export default "__VITE_ASSET__ClZ48e91__"